import { createSelectElement } from "../utils/input";
import { isMobile } from "../utils/detection";

const TimeComponent = (el) => {
  const children = [...el.children];

  el.style.position = "relative";
  el.style.overflow = "hidden";

  children.forEach((child) => {
    child.style.position = "relative";
    child.style.userSelect = "none";
    child.style.zIndex = 1;
    child.style.pointerEvents = "none";
  });

  const options = [];
  for (let i = 0; i < 10; i++) {
    const hour = 9 + i;
    const label =
      hour < 12
        ? `${hour}:00 AM`
        : hour === 12
          ? "12:00 PM"
          : `${hour - 12}:00 PM`;
    options.push({ value: label, label });
  }

  const select = createSelectElement(
    {
      name: el.dataset.name || "time",
      type: "time",
      required: el.dataset.required === "true",
      value: el.querySelector("[data-value]").textContent,
    },
    options,
  );

  if (el.dataset.id) select.id = el.dataset.id;
  if (el.dataset.name) select.setAttribute("data-name", el.dataset.name);

  select.addEventListener("change", (e) => {
    el.querySelector("[data-value]").textContent = e.target.value;
  });

  el.appendChild(select);

  if (!isMobile()) {
    el.addEventListener("click", () => {
      select.showPicker();
    });
  }
};

export default TimeComponent;
